module.exports = __webpack_public_path__ + "img/retail_app.2de2648b.png";